import TableSection from "./components/TableSection";
import { ReactComponent as ID } from "@/assets/icons/ID.svg";
import "./style.scss";
import getStockDetailInteractor from "@/@core/interactor/stock/get-stock-detail.interactor";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Product, ProductUnit } from "@/@core/entity/product.entity";
import { Warehouse } from "@/@core/entity/warehouse.entity";

const StockQuantityAdd = () => {
  const location = useLocation();
  const { state } = location;
  const { stockId } = state;
  const [product, setProduct] = useState<Product>();
  const [wareHouse, setWareHouse] = useState<Warehouse>();
  const [productUnits, setProductUnits] = useState<ProductUnit[]>([]);
  const [serialNumber, setSerialNumber] = useState("");

  useEffect(() => {
    getDetailStock();
  }, []);

  useEffect(() => {
    getDetailStock();
  }, [serialNumber]);

  const getDetailStock = async () => {
    try {
      const response = await getStockDetailInteractor({ stockId, serial_number: serialNumber });
      const {
        data: { data },
      } = response;
      setProduct(data.product);
      setWareHouse(data.warehouse_source);
      setProductUnits(data.product_unit);
    } catch {
      setProductUnits([]);
    }
  };

  return (
    <>
      <div className="stock-quantity-add-page-wrapper">
        <div className="header-page">
          <div>
            <h1>Add Stock Quantity</h1>
            <span className="sub-title">
              Scan the product to record as stock.
            </span>
          </div>
        </div>
        <div className="divider" />

        <div className="scroll-wrapper">
          <div className="stock-product-info-wrapper">
            <div className="row">
              <div className="label-wrapper">
                <span>Product Information</span>
              </div>
              <div className="info-wrapper">
                <div className="column">
                  <span className="title">Master SKU</span>
                  <span className="content">{product?.master_sku}</span>
                </div>
                <div className="column">
                  <span className="title">Season</span>
                  <span className="content">{product?.season}</span>
                </div>
                <div className="column">
                  <span className="title">Size</span>
                  <span className="content">{product?.size}</span>
                </div>
                <div className="column">
                  <span className="title">Colour</span>
                  <span className="content">{product?.colour}</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="label-wrapper">
                <span>Warehouse</span>
              </div>
              <div className="info-wrapper">
                <div className="column">
                  <span className="title">Warehouse Name</span>
                  <span className="content">{wareHouse?.name}</span>
                </div>
                <div className="column">
                  <span className="title">Warehouse Location</span>
                  <span className="content">
                    {/* {" "}
                  <ID width={20} height={20} /> Sunter, Jakarta Utara, DKI
                  Jakarta */}
                    {wareHouse?.address}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="divider" />
          <div className="content">
            <TableSection
              productUnits={productUnits}
              reFetchData={getDetailStock}
              changeSerialNumber={setSerialNumber}
              serialNumber={serialNumber}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StockQuantityAdd;
